import * as React from 'react';
import { Star } from 'lucide-react';
import { FeaturedProduct } from '../../types/landing';
import { Slider } from './Slider';
import { ProductCard } from './ProductCard';
import { route } from '../../utils/route';
import { usePage } from '@inertiajs/react';

interface FeaturedProductsSliderProps {
  products: FeaturedProduct[];
}

export function FeaturedProductsSlider({
  products
}: FeaturedProductsSliderProps): React.ReactElement {
  const { defaultCategorySlug } = usePage<{ defaultCategorySlug: string }>().props;
  return (
    <Slider
      title="Productos Destacados"
      shortTitle="Destacados"
      icon={<Star size={24} />}
      viewAllLink={route('products.index', { cat: defaultCategorySlug })}
      viewAllText="Explorá el mercado"
    >
      {products.map(product => (
        <ProductCard
          key={product.id}
          product={product}
        />
      ))}
    </Slider>
  );
}
